import { useParams } from "react-router-dom";
import useMinigridCore from "./core/useMinigridCore";
import useSingleMinigirdCore from "./core/useSingleMinigirdCore";
import useLiveSnapshotCore from "./core/useLiveSnapshotCore";
import { useAuth } from "../../auth/hooks";
import usePaginationSearchURL from "../../../common/hooks/usePaginationSearchURL";

export const useMinigrid = () => {
  const { authState } = useAuth();
  const { getCurrentPage, goToPage, setQuerySearch, getQuerySearch } =
    usePaginationSearchURL();

  const getUserId = () => {
    return authState.authData?.userId || null;
  };
  const getAccoundId = () => {
    return authState.authData?.accountId || null;
  };
  return useMinigridCore({
    getCurrentPage,
    goToPage,
    setQuerySearch,
    getQuerySearch,
    getAccoundId,
    getUserId,
  });
};

export const useSingleMinigrid = (minigridId?: string) => {
  let minigridIdFound = minigridId;
  const params = useParams();

  if (!minigridId) {
    minigridIdFound = params.minigridId;
  }

  return useSingleMinigirdCore({
    minigridId: minigridIdFound || "",
  });
};

export const useLiveSnapshot = (minigridId?: string) => {
  let minigridIdFound = minigridId;
  const params = useParams();

  if (!minigridId) {
    minigridIdFound = params.minigridId;
  }

  return useLiveSnapshotCore({
    minigridId: minigridIdFound || "",
  });
};

export default useMinigrid;
